import React from 'react';

import cn from 'classnames';

import { Gender } from '@appTypes/enums';

import Avatar from '../Avatar';
import styles from './PersonAvatar.less';
import Placeholder from './components/Placeholder';

interface PersonAvatarProps {
  className?: string;
  bordered?: boolean;
  isAdult: boolean;
  gender?: string;
  transparent?: boolean;
  pictureUrl?: string;
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const PersonAvatar: React.FC<PersonAvatarProps> = ({
  isAdult,
  gender,
  className,
  bordered = true,
  transparent,
  pictureUrl,
  size,
  ...rest
}) => {
  const title = isAdult ? 'Adult' : 'Youth';
  const isFemale = gender === Gender.F;
  const classNames = cn(
    styles.avatar,
    {
      [styles.transparent]: transparent,
      [styles.bordered]: bordered,
      [styles.adult]: isAdult,
    },
    size && styles[size],
    className,
  );

  return (
    <Avatar
      className={classNames}
      title={title}
      bordered={bordered}
      placeholder={
        <Placeholder
          isFemale={isFemale}
          isAdult={isAdult}
          pictureUrl={pictureUrl}
        />
      }
      {...rest}
    />
  );
};

export default PersonAvatar;
